import { FundItem } from 'common-components/fund'
import { Emphasized } from 'common-components/text'
import React from 'react'

const sortFunds = (a, b) => {
  if (b.riskLevel !== a.riskLevel) {
    return b.riskLevel - a.riskLevel
  } else {
    return a.code < b.code ? -1 : a.code > b.code ? 1 : 0
  }
}

export const FundList = ({ allFunds, toggleFund, updateFundPercent }) => (
  <div className="fund-list">
    <Emphasized>กรุณาเลือกกองทุนโดยประเมินจากความเสี่ยงของท่าน</Emphasized>
    {allFunds.map(({ categoryName, funds }, index) => (
      <div key={`fund-${index}`} className="fund-group">
        <div className="fund-title">{categoryName}</div>
        {funds.sort(sortFunds).map((item) => {
          return (
            <FundItem
              key={`fund-${item.code}`}
              onToggle={toggleFund}
              onChangeAllocationPercent={updateFundPercent}
              {...item}
            />
          )
        })}
      </div>
    ))}
  </div>
)
